"use client";

/**
 * Theme Provider
 * Client boundary around next-themes so the server-component root layout
 * can mount it. attribute="class" matches theme.css's Tailwind 4
 * `@custom-variant dark (&:is(.dark *))`. next-themes persists the choice
 * in localStorage ("theme" key) and injects a blocking script so the
 * class is applied before first paint (no flash of wrong theme).
 */

import { ThemeProvider as NextThemesProvider } from "next-themes";
import { MotionConfig } from "motion/react";
import { type ReactNode } from "react";

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <MotionConfig reducedMotion="user">{children}</MotionConfig>
    </NextThemesProvider>
  );
}
